import React, { useState, useEffect } from "react";

export default function InterstitialAd({ isOpen, onClose }) {
  const [timer, setTimer] = useState(5);

  useEffect(() => {
    let interval;
    if (isOpen) {
      setTimer(5); // Reset timer whenever ad opens
      interval = setInterval(() => {
        setTimer((t) => (t > 0 ? t - 1 : 0));
      }, 1000);

      // ✅ TELL GOOGLE TO LOAD THE REAL AD WHEN POPUP OPENS
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense Error: ", e);
      }
    }
    return () => clearInterval(interval);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="ia-overlay">
      <style>{`
        .ia-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(15, 23, 42, 0.95);
          backdrop-filter: blur(12px);
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: iaFadeIn 0.3s ease;
        }
        .ia-card {
          width: 100%;
          max-width: 400px;
          background: white;
          border-radius: 20px;
          overflow: hidden;
          position: relative;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          min-height: 350px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .ia-close {
          position: absolute;
          top: 15px; right: 15px;
          background: rgba(0,0,0,0.1);
          color: #334155;
          border: none;
          padding: 8px 16px;
          border-radius: 50px;
          font-weight: 800;
          font-size: 12px;
          cursor: pointer;
          z-index: 10;
          transition: background 0.2s;
        }
        .ia-close:hover {
          background: rgba(0,0,0,0.2);
        }
        .ia-close.disabled { 
          opacity: 0.5; 
          cursor: not-allowed; 
          background: #e2e8f0;
        }
        .ia-badge {
          position: absolute;
          top: 15px; left: 15px;
          background: #cbd5e1;
          color: #1e293b;
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 10px;
          font-weight: 900;
          z-index: 10;
        }
        .real-ad-wrapper {
          padding: 60px 20px 20px 20px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        @keyframes iaFadeIn { from { opacity: 0; } to { opacity: 1; } }
      `}</style>

      <div className="ia-card">
        <div className="ia-badge">SPONSORED</div>
        
        <button 
          className={`ia-close ${timer > 0 ? "disabled" : ""}`} 
          onClick={timer === 0 ? onClose : null}
        >
          {timer > 0 ? `Wait ${timer}s` : "✕ Close"}
        </button>
        
        {/* ✅ REAL GOOGLE AD GOES HERE */}
        <div className="real-ad-wrapper">
          <ins 
            className="adsbygoogle"
            style={{ display: "block", width: "100%", minHeight: "250px" }}
            data-ad-client="ca-pub-3034885339654373"
            data-ad-slot="5519297478" /* 🚨 YOU MUST REPLACE THIS */
            data-ad-format="auto"
            data-full-width-responsive="true">
          </ins>
        </div>
      </div>
    </div>
  );
}